import type { MainMenuItem } from '../side-menu-interfaces';
import { isMenuItemVisible, isSubMenuItemVisible } from './is-menu-item-visible';

type FilterConfig = {
  isDriver: boolean;
  isSiteAvailable: boolean;
  mainRoleId: string;
};

export function filterMenuItems(menuItems: MainMenuItem[], config: FilterConfig) {
  const { isDriver, isSiteAvailable, mainRoleId } = config;

  const filteredMenuItems: MainMenuItem[] = [];

  for (const menuItem of menuItems) {
    if (isMenuItemVisible(menuItem, { isDriver, isSiteAvailable, mainRoleId })) {
      filteredMenuItems.push({
        ...menuItem,
        subMenuItems: menuItem.subMenuItems.filter(subMenuItem =>
          isSubMenuItemVisible(subMenuItem, { isDriver, isSiteAvailable, mainRoleId })
        )
      });
    }
  }

  return filteredMenuItems;
}
